<template>
  <div class="main-content">
    <ValidationObserver ref="observer">
      <div class="main-content__csv-box">
        <b-row>
          <b-col class="form-group">
            <label>From date</label>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <DateInput v-model="fromDate"/>
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </b-col>
          <b-col class="form-group">
            <label>To date</label>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <DateInput v-model="toDate"/>
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </b-col>
        </b-row>

        <div class="form-group">
          <label>Position</label>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <SelectPositionInput class="form-control" v-model="position" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label>Kind</label>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <SelectScheduleTypeInput class="form-control"
              v-model="scheduleType" :isDownloadOthers="true" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>

        <div class="d-flex justify-content-center mt-5">
          <b-button pill variant="primary" @click="download">
            Download
          </b-button>
        </div>
      </div>
    </ValidationObserver>

    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { Moment } from 'moment'
// @ts-expect-error 型チェック不要部分
import FileSaver from 'file-saver'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Position } from '@/store/master/types'
import { DownloadOtherSchedulesCsvConditions } from '@/store/timesheets/types'
import SelectPositionInput from '@/components/parts/inputItem/SelectPositionInput.vue'
import DateInput from '@/components/parts/inputItem/DateInput.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import SelectScheduleTypeInput from '@/components/parts/inputItem/SelectScheduleTypeInput.vue'
import { scheduleType } from '@/store/schedules/types'
import _ from 'lodash'

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    DateInput,
    SelectPositionInput,
    SelectScheduleTypeInput,
    Loading,
  },
})
export default class TimesheetDownloadOthers extends Vue {
  private fromDate!: Moment|null

  private toDate!: Moment|null

  private position!: Position|null

  private scheduleType!: scheduleType|null

  private isLoading: boolean = false

  private created() {
    this.fromDate = null
    this.toDate = null
    this.position = null
    this.scheduleType = null
  }

  private async download() {
    const isOk = await (this.$refs.observer as any).validate()
    if (isOk !== true) {
      return
    }

    if (this.isLoading) {
      return
    }
    this.isLoading = true

    const from: Moment = this.fromDate as Moment
    const to: Moment = this.toDate as Moment
    const position: Position = this.position as Position
    const type: scheduleType = this.scheduleType as scheduleType

    const conditions: DownloadOtherSchedulesCsvConditions = {
      fromDate: from,
      toDate: to,
      position,
      scheduleType: type,
    }

    try {
      const { data } = await this.$store.dispatch('downloadOtherSchedulesCsv', conditions)
      const blob = new Blob([data], { type: 'text/plain;charset=utf-8' })
      FileSaver.saveAs(blob, `lesson_schedules-${from.format('YYYYMMDD')}-${to.format('YYYYMMDD')}-${position.name}-${type}.csv`)

      this.isLoading = false
      this.$bvModal.msgBoxOk('Success!')
    } catch (error: any) {
      this.isLoading = false
      const message = _.has(error, 'response') ? error.response.data.message : error.message
      this.$bvModal.msgBoxOk(`Failed. ${message}`)
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}
</style>
